import React from 'react'
import './DevSecOpsContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'

export class DevSecOpsContent extends React.Component {
  render() {
    return (
      <div className="devsecops-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Rackner is a recognized industry leader in DevSecOps, serving as a
            driving force behind multiple DoD software factories across
            the Air Force, Army, and Navy.
          </div>
        </div>

        <section className="padding-large">
          <div className="row">
            <div className="col-md-12">
              <h2>Kubernetes Excellence</h2>
              <p>
                As a Kubernetes Certified Service Provider with numerous Certified
                Kubernetes Administrators including at the executive level, Rackner
                has deployed and managed Kubernetes clusters using various
                distributions including Rancher RKE2, OpenShift, EKS, GKE, and AKS
                across air-gapped, edge, and hybrid cloud environments.
              </p>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Core Capabilities</h2>
          <div className="row capabilities-row">
            <div className="col-md-3">
              <div className="capability-box">
                <div className="number">700+</div>
                <div className="label">Reusable DoD-Grade DevSecOps Pipelines</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="capability-box">
                <div className="number">&lt;30</div>
                <div className="label">Days to Authority to Operate</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="capability-box">
                <div className="number">100%</div>
                <div className="label">Security Validation Pass Rate</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="capability-box">
                <div className="number">4x</div>
                <div className="label">Faster Ticket Resolution vs. Incumbent</div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <h2>Security-First Approach</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="feature-block">
                <h3>Automated Security Controls</h3>
                <p>
                  Embed security into every stage of the software development
                  lifecycle with automated code scanning and compliance validation
                  aligned with the DoD DevSecOps Reference Design and DISA STIGs.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="feature-block">
                <h3>Pre-Hardened Containers</h3>
                <p>
                  Leverage pre-hardened container images from Iron Bank and
                  comprehensive CI/CD integration to accelerate secure deployments
                  and streamline ATO processes.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="feature-block">
                <h3>Infrastructure as Code</h3>
                <p>
                  Apply MOSA design patterns with Infrastructure-as-Code using
                  Terraform and Ansible to maintain interoperability while enabling
                  rapid, secure delivery.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="feature-block">
                <h3>GitOps Practices</h3>
                <p>
                  Implement GitOps methodologies for declarative infrastructure
                  management across classification levels from IL2 to IL6 with full
                  audit trails.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="split">
          <h2>Proven Track Record</h2>
          <div className="text-wrap">
            <p>
              On Platform One, Rackner quadrupled ticket resolution speed versus
              the incumbent, completing over 450 tickets and 100 critical mission
              updates in just three months with 100% of releases passing security
              validation on first submission. Our teams consistently deliver
              exceptional results by combining deep technical expertise with
              mission understanding.
            </p>
          </div>
          <div className="button-wrap">
            <Link to="/kubernetes">
              <button className="btn-raised-light-blue-inverse big">
                Explore Our Kubernetes Expertise
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'contact'} linkText={'Get Started'} />
      </div>
    )
  }
}

export default DevSecOpsContent
